/*
 * Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* projectlijst.ts
* Datatable voor projecten
* 3-11-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Component} from '@angular/core';
import {Datatablescherm} from '../abstracts/datatablescherm.class';
import {DatatableDef} from 'sihw-ng/datatable/datatable.component';
import {Project} from '../../models/project';
import {ProjectFunctie} from '../../models/project_functie';

@Component({
  selector: 'projectlijst',
  templateUrl: './projectlijst.html'
})
export class Projectlijstscherm extends Datatablescherm {
  _starttitle = 'Projecten';
  icon = 'fas fa-hard-hat';
  editscherm = 'Projectedit';
  model = Project;
  //fixedWidth = '80vw';

  tableQuery = Project.recordquery([ProjectFunctie], []);


  public readonly tableDefinition: DatatableDef = {
    // track: 'trackerId', //eigenljk beter om gewoon object-id te doen
    standaardsortering: {
      key: 'omschrijving',
      richting: 1
    },
    velden: {
      alert: {
        label: null,
        prop: 'heeftKritiek',
        type: 'string',
        filter: false,
        html: true,
        format: (heeftkritiek, rij) => {
          let html = '';
          if (heeftkritiek) {
            html += '<span class="fas fa-exclamation-triangle text-warning" title="Er zijn problemen bij dit project"></span>';
          }
          if (rij?.externe_werkmaatschappij) {
            html += '<span class="fas fa-building text-info" title="Op dit project zie je de diensten uit een andere werkmaatschappij, waarop wij mensen mogen plannen en waarop de uren uiteindelijk worden geschreven en gefactureerd. De bedoeling is dat dit project in Exact goed gekoppeld is aan de andere werkmaatschappij als klant, met de juiste functies in de WBS."></span>';
          }
          return html;
        }
      },
      kleur: {
        label: null, //expliciet geen label
        prop: 'kleur',
        type: 'string',
        filter: false, //expliciet geen filter
        html: true,
        format: (kleur) => {
          if (kleur) {
            return `<div class="text-center"><span class='kleur' style="background-color: ${kleur};"></span></div> `;
          } else {
            return '';
          }
        }
      },
      omschrijving: {
        label: 'Naam' //dit is de omschrijving in exact
      },
      naam: {
        label: 'Code'
      },
      klantnaam: {
        label: 'Klant',
        type:'enum'
      },
      locatie: {
        label: 'Locatie'
      },
      werkorder: {
        label: 'Werkorder'
      },
      begindatum: {
        label: 'Van',
        type: ['moment', {format: 'DD-MM-YYYY'}]
      },
      einddatum: {
        label: 'Tot',
        type: ['moment', {format: 'DD-MM-YYYY'}]
      },
      factureerbaar: {
        type: 'bool',
        label: 'Factureerbaar'
      },
      numFuncties: {
        label: 'Functies',
        type: 'int'
      }
    }
  };

  //constructor ivm injection
  constructor() {
    super('debug');
  }
}
